// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComplianceCertificatesComponent } from '../Components/compliance-certificates/compliance-certificates.component';

@NgModule({
  declarations: [
    ComplianceCertificatesComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ComplianceCertificatesComponent
  ]
})

export class ComplianceCertificatesModule { }
